// Toast notification system
const createNotificationSystem = () => {
  
  // Notification types configuration
  const notificationTypes = {
    success: {
      icon: `<svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
      </svg>`,
      classes: 'bg-green-50 border-green-200 text-green-800',
      iconClasses: 'text-green-400'
    },
    error: {
      icon: `<svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"></path>
      </svg>`,
      classes: 'bg-red-50 border-red-200 text-red-800',
      iconClasses: 'text-red-400'
    },
    warning: {
      icon: `<svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
      </svg>`,
      classes: 'bg-yellow-50 border-yellow-200 text-yellow-800',
      iconClasses: 'text-yellow-400'
    },
    info: {
      icon: `<svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path>
      </svg>`,
      classes: 'bg-blue-50 border-blue-200 text-blue-800',
      iconClasses: 'text-blue-400'
    }
  }
  
  // Show notification
  const show = (message, type = 'info', duration = 5000, options = {}) => {
    const container = document.getElementById('toast-container')
    const config = notificationTypes[type] || notificationTypes.info
    
    // Create unique ID for this notification
    const notificationId = `toast-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
    
    // Create notification element
    const notification = document.createElement('div')
    notification.id = notificationId
    notification.className = `
      w-full sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl border rounded-lg p-4 shadow-lg transform transition-all duration-300 ease-out
      ${config.classes} toast-enter
    `
    
    notification.innerHTML = `
      <div class="flex">
        <div class="flex-shrink-0">
          <div class="${config.iconClasses}">
            ${config.icon}
          </div>
        </div>
        <div class="ml-3 flex-1 min-w-0 break-words whitespace-normal">
          <p class="text-sm font-medium break-words whitespace-normal">
            ${message}
          </p>
          ${options.description ? `<p class="mt-1 text-sm opacity-90 break-words whitespace-normal">${options.description}</p>` : ''}
        </div>
        <div class="ml-4 flex-shrink-0 flex">
          <button 
            class="inline-flex text-gray-400 hover:text-gray-600 focus:outline-none focus:text-gray-600 transition ease-in-out duration-150"
            onclick="closeNotification('${notificationId}')"
          >
            <svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
            </svg>
          </button>
        </div>
      </div>
    `
    
    // Add to container
    container.appendChild(notification)
    
    // Trigger enter animation
    requestAnimationFrame(() => {
      notification.classList.remove('toast-enter')
      notification.classList.add('toast-enter-active')
    })
    
    // Auto-remove after duration
    if (duration > 0) {
      setTimeout(() => {
        closeNotification(notificationId)
      }, duration)
    }
    
    // Add to global for onclick handler
    window.closeNotification = closeNotification
    
    return notificationId
  }
  
  // Close specific notification
  const closeNotification = (notificationId) => {
    const notification = document.getElementById(notificationId)
    if (!notification) return
    
    notification.classList.remove('toast-enter-active')
    notification.classList.add('toast-exit-active')
    
    setTimeout(() => {
      if (notification.parentElement) {
        notification.parentElement.removeChild(notification)
      }
    }, 300)
  }
  
  // Close all notifications
  const closeAll = () => {
    const container = document.getElementById('toast-container')
    const notifications = container.children
    
    Array.from(notifications).forEach(notification => {
      closeNotification(notification.id)
    })
  }
  
  // Preset notification methods
  const success = (message, options = {}) => show(message, 'success', 5000, options)
  const error = (message, options = {}) => show(message, 'error', 8000, options)
  const warning = (message, options = {}) => show(message, 'warning', 6000, options)
  const info = (message, options = {}) => show(message, 'info', 5000, options)
  
  // Loading notification (persistent until manually closed)
  const loading = (message, options = {}) => {
    const loadingMessage = `
      <div class="flex items-center">
        <svg class="animate-spin -ml-1 mr-3 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        ${message}
      </div>
    `
    
    return show(loadingMessage, 'info', 0, options) // 0 duration = persistent
  }
  
  // Progress notification
  const progress = (message, percentage, options = {}) => {
    const progressMessage = `
      <div>
        <div class="flex items-center justify-between mb-2">
          <span class="text-sm font-medium">${message}</span>
          <span class="text-sm">${percentage}%</span>
        </div>
        <div class="w-full bg-gray-200 rounded-full h-2">
          <div class="bg-blue-600 h-2 rounded-full transition-all duration-300" style="width: ${percentage}%"></div>
        </div>
      </div>
    `
    
    return show(progressMessage, 'info', 0, options)
  }
  
  // Confirm dialog (using notification style)
  const confirm = (message, onConfirm, onCancel, options = {}) => {
    const confirmMessage = `
      <div>
        <p class="text-sm font-medium mb-3">${message}</p>
        <div class="flex space-x-2">
          <button 
            id="confirm-yes-btn" 
            class="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded text-white bg-red-600 hover:bg-red-700 focus:outline-none"
          >
            Conferma
          </button>
          <button 
            id="confirm-no-btn" 
            class="inline-flex items-center px-3 py-1.5 border border-gray-300 text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none"
          >
            Annulla
          </button>
        </div>
      </div>
    `
    
    const notificationId = show(confirmMessage, 'warning', 0, options)
    
    // Add event listeners
    setTimeout(() => {
      const confirmBtn = document.getElementById('confirm-yes-btn')
      const cancelBtn = document.getElementById('confirm-no-btn')
      
      if (confirmBtn) {
        confirmBtn.addEventListener('click', () => {
          closeNotification(notificationId)
          if (onConfirm) onConfirm()
        })
      }
      
      if (cancelBtn) {
        cancelBtn.addEventListener('click', () => {
          closeNotification(notificationId)
          if (onCancel) onCancel()
        })
      }
    }, 100)
    
    return notificationId
  }
  
  // Bulk operation progress
  const bulkProgress = (current, total, operation = 'Elaborazione') => {
    const percentage = Math.round((current / total) * 100)
    const message = `${operation} ${current} di ${total}`
    
    return progress(message, percentage, {
      description: `${percentage}% completato`
    })
  }
  
  // Network status notifications
  const networkError = () => {
    return error('Errore di connessione', {
      description: 'Controlla la connessione internet e riprova'
    })
  }
  
  const syncComplete = (count) => {
    return success(`Sincronizzazione completata`, {
      description: `${count} attività aggiornate con successo`
    })
  }
  
  return {
    show,
    closeNotification,
    closeAll,
    success,
    error,
    warning,
    info,
    loading,
    progress,
    confirm,
    bulkProgress,
    networkError,
    syncComplete
  }
}

export const notifications = createNotificationSystem()